export const voucherCodes = {
  VGV: 'VGV',
  SFV: 'SFV',
  REV: 'REV',
  ER_COMPENSATION: 'ER_COMPENSATION',
  ES_COMPENSATION: 'ES_COMPENSATION'
};

export const voucherTypes = {
  [voucherCodes.SFV]: 'S3 failed e-voucher',
  [voucherCodes.VGV]: 'Voyager group e-voucher',
  [voucherCodes.REV]: 'Replacement e-voucher',
  [voucherCodes.ER_COMPENSATION]: 'ER compensation e-voucher',
  [voucherCodes.ES_COMPENSATION]: 'ES compensation e-voucher'
};

export const esVoucherTypes = ['ES_COMPENSATION', 'ES_SERVICERECOVERY', 'ES_REPLACEMENT'];
export const erVoucherTypes = ['ER_COMPENSATION', 'ER_SERVICERECOVERY', 'ER_REPLACEMENT', 'TH_MIGRATED_COMPENSATION'];

export const minMaxValues = {
  [voucherCodes.SFV]: { min: 1, max: 8000 },
  [voucherCodes.VGV]: { min: 1, max: 10000 },
  [voucherCodes.REV]: { min: 1, max: 8000 }
};

export const VoucherStatus = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EXPIRED: 'Expired',
  REDEEMED: 'Redeemed'
};

export const VoucherLanguages = {
  EN: 'translations.english',
  FR: 'translations.french',
  NL: 'translations.dutch',
  DE: 'translations.german'
};

export const replaceVoucherErrorCodes = {
  unable_to_retrieve_voucher_from_code_or_alias: 'vouchers.associatedVoucherNotFound',
  associated_voucher_replaced: 'vouchers.associatedVoucherReplaced',
  value_exceeds_associated_voucher_value: 'vouchers.valueExceedsAssociatedVoucherValue'
};

export const voucherUpdateReasons = [
  {
    value: 'Customer Error',
    label: 'Customer Error'
  },
  {
    value: 'Death Illness',
    label: 'Death / Illness'
  },
  {
    value: 'Disruption',
    label: 'Disruption'
  },
  {
    value: 'Executive Decision',
    label: 'Executive Decision'
  },
  {
    value: 'Fraud',
    label: 'Fraud'
  },
  {
    value: 'Operator Error',
    label: 'Operator Error'
  },
  {
    value: 'Rest of the World Customer',
    label: 'Rest of the World Customer'
  },
  {
    value: 'Strike',
    label: 'Strike'
  },
  {
    value: 'Adyen Admin',
    label: 'Adyen Admin'
  }
];

export const BOOKING_DEPOSIT_AMOUNT_LESS_THAN_VOUCHER_BALANCE_ERROR_REASON = 'voucher_balance_is_less_than_booking_deposit_amount';

export const VOUCHER_TYPE_DISCOUNT = 'DISCOUNT';
export const VOUCHER_TYPE_PREPAID = 'PREPAID';
export const DISCOUNT_TYPE = 'DISCOUNT';
export const DISCOUNT_ERROR = 'discount_error';

export const DISCOUNT_STATION_DIRECTION_ORIGIN = 'ORIGIN';
export const DISCOUNT_STATION_DIRECTION_DESTINATION = 'DESTINATION';
export const DISCOUNT_STATION_DIRECTION_BOTH = 'BOTH';

export const BULK_VOUCHERS_PERCENTAGES = [25, 30, 50, 60, 75, 100, 125, 150, 175, 200];

export const BE_MY_GUEST_VOUCHER_DESCRIPTION = 'Discount - Be My Guest';
export const SILVER_VOUCHER_DESCRIPTION = 'Discount - Silver Voucher';
export const PUBLIC_VOUCHER_DESCRIPTION = 'Discount - Public';
export const SILVER_VOUCHER_DISCOUNT_DESCRIPTION = 'Discount - Silver Voucher - Free booking';

export const BULK_VOUCHERS_STATUS = {
  FAILED: 'FAILED',
  IN_PROGRESS: 'IN_PROGRESS',
  PROCESSED: 'PROCESSED',
  READY: 'READY'
};
